import { PrimaryInformationService } from './../../../services/primary-information/primary-information.service';
import { VideoArchivesSettingsService } from './../../../services/video-archives-settings/video-archives-settings.service';
import { AlertController, ModalController, PopoverController, ToastController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { PlatformService } from 'src/app/services/platform/platform.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video-archives-settings',
  templateUrl: './video-archives-settings.page.html',
  styleUrls: ['./video-archives-settings.page.scss'],
})
export class VideoArchivesSettingsPage implements OnInit {
  moment: any = moment;
  bucket_url = environment.s3_bucket_url;

  isAddVideoArchiveOpen: boolean = false;
  showVideoArchivesLoader: boolean = false;
  myVideoArchives: any = [];
  videoArchive: any = null;

  isMobileDevice: boolean;

  videoArchivesForm: FormGroup;
  subscription = new SubSink();

  isVideo: boolean = true;
  is_not_video_message = '';

  showSpinner: boolean = false;

  response_message: string = '';
  hasResponseError: boolean = false;

  video_name: string = null;
  account_type_id: string = '';

  video_thumbnail_preview: string;
  isImage: boolean = true;
  is_not_image_message = '';

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private videoService: VideoArchivesSettingsService,
    private toast: ToastController,
    private primaryInfoService: PrimaryInformationService,
    private alertCtrl: AlertController,
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.showVideoArchiveLoader();
    this.readyVideoArchivesForm();
    this.getMyVideoArchivesInfo();
    // this.getVideosData();
    this.getUserAccountType();
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  readyVideoArchivesForm() {
    this.videoArchivesForm = this.fb.group({
      video_type: [null, Validators.required],
      video_file: File,
      video_thumbnail: File,
      video_title: ['', [Validators.required, Validators.pattern(/\S+/)]],
      video_description: ['', [Validators.required, Validators.pattern(/\S+/)]],
      view_cost: [null],
      is_downloadable: ['', Validators.required],
      video_release_date: [null, Validators.required],
      video_release_end_date: [null, Validators.required],
      video_release_time: [null, Validators.required],
      video_duration: ['', [Validators.required, Validators.pattern(/\S+/)]],
    });

  }

  //GETTERS
  get video_type() {
    return this.videoArchivesForm.get('video_type');
  }
  get video_file() {
    return this.videoArchivesForm.get('video_file');
  }
  get video_thumbnail() {
    return this.videoArchivesForm.get('video_thumbnail');
  }
  get video_title() {
    return this.videoArchivesForm.get('video_title');
  }
  get video_description() {
    return this.videoArchivesForm.get('video_description');
  }
  get view_cost() {
    return this.videoArchivesForm.get('view_cost');
  }
  get is_downloadable() {
    return this.videoArchivesForm.get('is_downloadable');
  }
  get video_release_date() {
    return this.videoArchivesForm.get('video_release_date');
  }
  get video_release_end_date() {
    return this.videoArchivesForm.get('video_release_end_date');
  }
  get video_release_time() {
    return this.videoArchivesForm.get('video_release_time');
  }
  get video_duration() {
    return this.videoArchivesForm.get('video_duration');
  }
  //#GETTERS


  uploadVideo(event: any) {
    if (
      event.target.files &&
      event.target.files[0] &&
      event.target.files[0].type.includes('video/mp4')
    ) {
      this.isVideo = true;
      this.is_not_video_message = '';
      const reader = new FileReader();

      reader.onload = (_event: any) => {
        this.video_name = event.target.files[0].name;
        this.videoArchivesForm.get('video_file')?.setValue(event.target.files[0]);
        this.video_file.markAsDirty();
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.isVideo = false;
      this.video_name = null;
      this.videoArchivesForm.get('video_file')?.setValue(null);
      if (event.target.files[0] === undefined)
        this.is_not_video_message = "No video file selected";
      else
        this.is_not_video_message = "Only MP4 Video files can be uploaded";
    }

  }

  uploadImage(event: any) {
    if (
      event.target.files &&
      event.target.files[0] &&
      event.target.files[0].type.includes('image/')
    ) {
      console.log("file size => ", event.target.files[0].size);
      if (event.target.files[0].size <= 2000000) {
        const reader = new FileReader();
        console.log("selected img => ", event.target.files[0])
        reader.onload = (_event: any) => {
          var img = new Image;
          img.src = reader.result as string;
          img.onload = () => {
            // console.log("img width => ",img.width);
            // console.log("img height => ",img.height);
            if (img.width <= 630 && img.height <= 260) {
              this.video_thumbnail_preview = _event.target.result;
              this.videoArchivesForm.get('video_thumbnail')?.setValue(event.target.files[0]);
              this.video_thumbnail.markAsDirty();
              this.isImage= true;
              this.is_not_image_message = '';
            } else {
              this.isImage = false;
              this.is_not_image_message = "Image must not be greater than 630x260";
            }
            // console.log('video thumbnail ==> ', this.videoArchivesForm.get('video_thumbnail').value);
          };
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this.isImage = false;
        this.is_not_image_message = "Only files upto 2 MB can be uploaded";
      }
    } else {
      this.isImage = false;
      this.video_thumbnail_preview = null;
      this.videoArchivesForm.get('video_thumbnail')?.setValue(null);
      if (event.target.files[0] === undefined)
        this.is_not_image_message = "No image file selected";
      else
        this.is_not_image_message = "Only Image files can be uploaded";
    }
  }


  view_cost_validate() {
    if (this.video_type.value === 'public') {
      this.videoArchivesForm.get('view_cost').setValue(null);
      this.videoArchivesForm.controls['view_cost'].clearValidators();
    } else if (this.video_type.value === 'private') {
      this.videoArchivesForm.controls['view_cost'].setValidators([Validators.required, (control: AbstractControl) => Validators.min(3.99)(control), Validators.pattern("^[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]+$")]);
    }

    this.videoArchivesForm.controls['view_cost'].updateValueAndValidity();
  }


  getUserAccountType() {
    this.subscription.sink = this.primaryInfoService
      .getPrimaryInfo()
      .subscribe(
        (res_primaryInfo: any) => {
          // console.log("Account type id ------> ",res_primaryInfo.data.account_type_id);
          this.account_type_id = res_primaryInfo.data.account_type_id;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getMyVideoArchivesInfo() {
    this.subscription.sink = this.videoService
      .getMyUserVideos()
      .subscribe(
        (res: any) => {
          this.showVideoArchivesLoader = false;
          this.myVideoArchives = res.data;
          // console.log("my videos data ---> ",this.myVideoArchives);
        },
        (error) => {
          this.showVideoArchivesLoader = false;
          console.log(error);
        }
      );
  }

  submitVideoArchive() {
    this.showSpinner = true;
    let videoInfo = this.videoArchivesForm.value;
    // console.log(videoInfo);
    var form_data: FormData = new FormData();
    form_data.append('video_type', videoInfo?.video_type);
    form_data.append('video_file', videoInfo?.video_file);
    form_data.append('video_thumbnail', videoInfo?.video_thumbnail);
    form_data.append('video_title', videoInfo?.video_title);
    form_data.append('video_description', videoInfo?.video_description);
    form_data.append('view_cost', videoInfo?.view_cost);
    form_data.append('is_downloadable', videoInfo?.is_downloadable);
    form_data.append('video_release_date', videoInfo?.video_release_date);
    form_data.append('video_release_end_date', videoInfo?.video_release_end_date);
    form_data.append('video_release_time', videoInfo?.video_release_time);
    form_data.append('video_release_end_time', '23:59');
    form_data.append('video_duration', videoInfo?.video_duration);
    form_data.append('account_type', this.account_type_id);
    this.subscription.sink = this.videoService
      .createUserVideo(form_data)
      .subscribe(
        (res: any) => {
          this.showSpinner = false;
          // console.log('create video response ----------> ', res);
          this.hasResponseError = false;
          this.response_message = res.message;
          this.presentSuccessToast(this.response_message);
          this.videoArchivesForm.reset();
          this.video_name = null;
          this.video_thumbnail_preview = null;
          this.isAddVideoArchiveOpen = false;
          this.getMyVideoArchivesInfo();
        },
        (err: any) => {
          this.showSpinner = false;
          console.log('Error -------> ', err);
          this.hasResponseError = true;
          this.response_message = "An error occurred adding your Video Archive, please try again later.";
          this.presentErrorToast(this.response_message);
        }
      );
  }

  getVideoArchive(id) {
    this.subscription.sink = this.videoService
      .getUserVideo(id)
      .subscribe(
        (res: any) => {
          this.videoArchive = res.data;
          // console.log("videoArchive ==> ",this.videoArchive);
          this.readyEditFormData(this.videoArchive);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  openAddVideoArchive() {
    this.isAddVideoArchiveOpen = true;
    this.videoArchive = null;
    this.videoArchivesForm.reset();
    this.video_name = null;
    this.video_thumbnail_preview = null;
  }

  goBackToVideoArchivesList() {
    this.isAddVideoArchiveOpen = false;
    this.videoArchive = null;
    this.videoArchivesForm.reset();
    this.video_name = null;
    this.video_thumbnail_preview = null;
  }

  goToEditForm(id) {
    // console.log("video archive id --> ", id);
    this.getVideoArchive(id);
  }

  readyEditFormData(videoArchive) {
    this.videoArchivesForm.patchValue({
      video_type: videoArchive.video_type,
      video_file: File,
      video_thumbnail: File,
      video_title: videoArchive.video_title,
      video_description: videoArchive.video_description,
      view_cost: videoArchive.view_cost === null || videoArchive.view_cost === "null" ? null : videoArchive.view_cost,
      is_downloadable: videoArchive.is_downloadable,
      video_release_date: videoArchive.video_release_date,
      video_release_end_date: videoArchive.video_release_end_date,
      video_release_time: videoArchive.video_release_time,
      video_duration: videoArchive.video_duration,
    });
    this.video_name = videoArchive?.video_name ? videoArchive.video_name : null;
    this.video_thumbnail_preview = videoArchive?.thumbnail_s3_uid ? this.bucket_url + videoArchive.thumbnail_s3_uid : null;
    this.isAddVideoArchiveOpen = true;
  }

  updateVideoArchive(id) {
    this.showSpinner = true;
    // console.log("update video archive id --> ",id);
    let videoInfo = this.videoArchivesForm.value;
    // console.log('form value ==>', this.videoArchivesForm.value);
    var form_data: FormData = new FormData();
    form_data.append('video_type', videoInfo?.video_type);
    form_data.append('video_file', videoInfo?.video_file);
    form_data.append('video_thumbnail', videoInfo?.video_thumbnail);
    form_data.append('video_title', videoInfo?.video_title);
    form_data.append('video_description', videoInfo?.video_description);
    form_data.append('view_cost', videoInfo?.view_cost);
    form_data.append('is_downloadable', videoInfo?.is_downloadable);
    form_data.append('video_release_date', videoInfo?.video_release_date);
    form_data.append('video_release_end_date', videoInfo?.video_release_end_date);
    form_data.append('video_release_time', videoInfo?.video_release_time);
    form_data.append('video_release_end_time', '23:59');
    form_data.append('video_duration', videoInfo?.video_duration);
    form_data.append('account_type', this.account_type_id);
    this.subscription.sink = this.videoService
        .updateUserVideo(id, form_data)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            // console.log('update video response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);

            this.videoArchivesForm.reset();
            this.video_name = null;
            this.video_thumbnail_preview = null;
            this.isAddVideoArchiveOpen = false;
            this.getMyVideoArchivesInfo();
          },
          (err: any) => {
            this.showSpinner = false;
            console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred updating your Video Archive, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }

  deleteVideoArchive(id) {
    // console.log("delete event id --> ",id);
    this.subscription.sink = this.videoService
        .deleteUserVideo(id)
        .subscribe(
          (res: any) => {
            // console.log('delete event response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
            this.getMyVideoArchivesInfo();
          },
          (err: any) => {
            console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred deleting your Video Archive, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }

  showVideoArchiveLoader() {
    this.showVideoArchivesLoader = true;
  }


  closeModal() {
    return this.modalCtrl.dismiss();
  }

  async deleteConfirm(video_id) {
    let alert = this.alertCtrl.create({
      message: 'Are you sure, you want to delete this video?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: () => {
            this.deleteVideoArchive(video_id);
          }
        }
      ]
    });
    (await alert).present();
  }

}
